// JsFromRoutes CacheKey 0529c9ff542cee10646f59b373cc6a74
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/local_favorites'),
}
